import React from "react";
import { TitleWithSearch } from "../../components/titleWithSearch";
import "../../assets/styles/tableEap.css";
import "../../assets/styles/input.css";
import "../../assets/styles/modalComponent.css";
import "../../assets/styles/newProject.css";
import { animationModal } from "../../utils";
import { Link } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import chevron from '../../assets/img/Icon awesome-chevron-circle-right.svg'
import backHeader from '../../assets/img/Back - Header.svg'
import upload from '../../assets/img/Icon awesome-upload.svg'
import plusIcon from '../../assets/img/Icon-ionic-ios-add.svg'
import { ModalInfos } from "../../components/modal"
import files from '../../assets/img/Icon metro-files-empty.svg'
import { ModalSure } from "../../components/modalExcluir"
import Loading from "../../components/Loading"
import axiosInstance from "../../auth/axiosInstance";

const NovoProjeto = () => {
  const [uploaded, setUploaded] = React.useState(false)
  const [initialData, setInitialData] = React.useState([])
  const [label, setlabel] = React.useState('Projeto atualizado com sucesso!')
  const [labelError, setlabelError] = React.useState({ label: 'Erro ao adicionar Projeto!', sugestao: 'Favor revisar nome do Projeto ou Arquivo' })
  const [show, setShow] = React.useState(false)
  const [showModal, setShowModal] = React.useState(false)
  const [showModal2, setShowModal2] = React.useState(false)
  const [showModal3, setShowModal3] = React.useState(false)
  const [values, setValues] = React.useState();
  const [eapId, setEapId] = React.useState(0)
  const [selected, setSelected] = React.useState(null);
  const [searchValue, setSearchValue] = React.useState("");
  const [modEdit, setModEdit] = React.useState(false)

  const onChange = (event) => {
    if (event.target.name === 'eapId') {
      const inputValue = event.target.value;
      const regex = /[S,s][A-Z,a-z]{3}[A-Z,a-z]{2}\d{2}/;
      const isValid = regex.test(inputValue);
      if (isValid) {
        setValues({
          ...values, [event.target.name]:
            event.target.value
        });
        const campo = document.getElementById('eapId')
        campo.style.border = '1px solid black'
      } else {
        const campo = document.getElementById('eapId')
        campo.style.border = '1px solid red'
      }
    } else {
      setValues({
        ...values, [event.target.name]:
          event.target.value
      });
    }

  };
  const [file, setFile] = React.useState(null);
  const handleChange = (file) => {
    setFile(file);
  };
  const [obraSelecionada, setObraSelecionada] = React.useState({})

  async function getInitial() {
    await axiosInstance(`filter/Eap_Info/`)
      .then(res => {
        setInitialData(res.data)
      })
  }

  React.useEffect(() => {
    getInitial()
  }, [])

  React.useEffect(() => {
    getInitial()
  }, [uploaded])

  const [isLoading, setIsLoading] = React.useState(false);

  function callLoading() {
    setIsLoading(true)
    postFile()
  }

  async function postFile() {
    let form = new FormData()
    form.append('file', file)
    Object.keys(values).forEach((value, i) => {
      form.append(value, Object.values(values)[i])
    })
    try {
      await axiosInstance.post(`file`, form)
        .then(res => {
          if (res.status === 201) {
            setIsLoading(false)
            setlabel('Projeto inserido com sucesso!')
            setShowModal(true)
            animationModal('modal-new-action', 'background-new-plan')
            setValues(undefined)
            // setTimeout(() => {
            //     getInitial()
            //   }, 10000);
            getInitial();
            setUploaded(!uploaded)
          }
        })
    } catch (error) {
      setIsLoading(false)
      console.log(error)
      setlabelError({ label: 'Erro ao adicionar Projeto!', sugestao: 'Favor revisar nome do Projeto ou Arquivo' })
      setShowModal2(true)
    }
  }

  async function putGeral(sheet, id, eapid) {
    try {
      await axiosInstance.put(`filter/${sheet}/${id}/${eapid}`, values)
        .then(res => {
          if (res.status === 200) {
            setlabel('Projeto atualizado com sucesso!')
            setShowModal(true)
            animationModal("modal-edit", "background-edit")
            setValues(undefined)
            getInitial()
          }
        })
    } catch (error) {
      console.log(error)
      setlabelError({ label: 'Erro ao atualizar Projeto!', sugestao: 'Favor revisar dados inseridos' })
      setShowModal2(true)
    }

  }

  async function deleteEap() {
    try {
      await axiosInstance.delete(`${eapId}`)
        .then(res => {
          if (res.status === 200) {
            setlabel('Projeto removido com sucesso!')
            setShowModal(true)
            setValues(undefined)
            setShowModal3(false)
            setSelected(null)
            getInitial()
          }
        })
    } catch (error) {
      setlabelError({ label: 'Erro ao deletar Projeto!', sugestao: 'Favor tente novamente' })
      setShowModal2(true)
      setSelected(null)
      setShowModal3(false)
    }

  }

  const searchHandler = ({ target }) => {
    setSearch(target.value);
  };

  const [search, setSearch] = React.useState('');

  const lowerSearch = search.toLowerCase();
  const itemsFilter = initialData.filter((element) => element.eapId.toLowerCase().includes(lowerSearch))

  return (
    <section className="body-table-eap">
      <div style={isLoading ? { display: "flex" } : { display: "none" }} className="absolute-loading">
        < Loading content="Aguarde enquanto estamos carregando a planilha no banco" />
      </div>
      <TitleWithSearch
        title='Obras'
        label='Pesquisar Obras'
        chevron={false}
        route='/'
        botao={true}
        onClick={() => animationModal('modal-new-action', 'background-new-plan')}
        fontSizeButton='17px'
        labelButton='Novo'
        onChange={searchHandler}
        iconButton={plusIcon}
        placeholder='Pesquise por Nome da Obra'
      />

      <div className="table-wrapper">
        <table className="table-eap table-project">
          <thead>
            <tr>
              <th>Nome do Projeto</th>
              <th>Fases</th>
              <th>Tipo</th>
              <th>Moeda</th>
              <th>Potência de TI</th>
              <th>Área</th>
              <th>Tipologia</th>
              <th>WKT</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              itemsFilter.map((value, i) => {
                return (

                  <tr onClick={selected !== null && value === selected ? () => setSelected(null) : () => setSelected(value)} className='tr-body-eap'>
                    <td>{value?.eapId}</td>
                    <td>{value.fases === 'null' ? ' ' : value.fases}</td>
                    <td>{value.tipo === 'null' ? ' ' : value.tipo}</td>
                    <td>{value.moeda === 'null' ? ' ' : value.moeda}</td>
                    <td>{value.potencia === 'null' ? ' ' : value.potencia}</td>
                    <td>{value.area === 'null' ? ' ' : value.area}</td>
                    <td>{value.tipologia === 'null' ? ' ' : value.tipologia}</td>
                    <td>{value.wkt === 'null' ? ' ' : value.wkt}</td>
                    <td>
                      <Link to={`/eap/${value?.eapId}`}>
                        <button><img src={chevron} alt='chevron' /></button>
                      </Link>
                    </td>
                    <div style={selected === value ? { display: 'flex' } : { display: 'none' }} className="options-cpu">
                      <button onClick={() => { setShowModal3(true); setEapId(value?.eapId) }}>
                        Excluir
                      </button>
                      <button onClick={() => {
                        animationModal("modal-edit", "background-edit");
                        setObraSelecionada(value);
                        setModEdit(true);
                        // console.log("abriu")
                      }}>
                        Editar
                      </button>
                    </div>

                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>

      <div id='background-new-plan' className="background-new-plan">
        <section id="modal-new-action" className="modal-new-action">
          <div onClick={() => (animationModal('modal-new-action', 'background-new-plan'), setFile(null), setShow(false))} className="fechar-button-style">
            <img src={backHeader} alt='back' />
            <img src={backHeader} alt='back' />
            <h2 className="montserrat ">Fechar</h2>
          </div>
          <h1 className="montserrat azul w600">{show ? values?.eapId : 'Novo Projeto'}</h1>
          <p className="montserrat" style={{ marginTop: 10 }}>{show ? 'Deseja incluir informações adicionais?' : 'Preencha as informações'}</p>
          <div style={show ? { display: 'none' } : { display: 'block' }} className="content-inputs">
            <div className="input-component">
              <div>
                <h3 className="montserrat">Nome do Projeto</h3>
                <h5 className='w600'>*</h5>
              </div>
              <input name="eapId" onChange={onChange} placeholder='Digite Aqui' required type='text' id="eapId" />
              <h4 className="montserrat">Exemplo: SGRUTB80</h4>
            </div>
            {
              file !== null ?
                <div className="selected-file">
                  <img src={files} alt='file' />
                  <h4>{file !== null ? file.name : 'Nome do Arquivo'}</h4>
                  <h5 onClick={() => setFile(null)}>X</h5>
                </div> :
                <div className="input-component2">
                  <div className="handle-change-content">
                    <img src={upload} alt="upload" style={{ width: 40 }} />
                    <FileUploader
                      classes="handle-change"
                      handleChange={handleChange}
                      name="file"
                    />
                    <p>Arraste o Documento ou Clique no box para importar</p>
                  </div>
                  <h4 className="montserrat" style={{ marginTop: 10 }}>
                    Tamanho Máximo do Arquivo: 2MB
                  </h4>
                  <h4 className="montserrat">Tipos de Documentos: xlsx.</h4>
                </div>
            }
          </div>

          <div style={show ? { display: 'block' } : { display: 'none' }} className="content-inputs">
            <div className="input-component">
              <div>
                <h3 className="montserrat">Fases</h3>
              </div>
              <input placeholder='Digite Aqui' name="fases" onChange={onChange} type='text' />
              <h4 className="montserrat">Exemplo: 1</h4>
            </div>
            <div className="input-component">
              <div>
                <h3 className="montserrat">Tipo</h3>
              </div>
              <select name="tipo" onChange={onChange}>
                <option>Selecione o Tipo</option>
                <option>Convencional</option>
                <option>Hibrid</option>
                <option>Fastdeploy</option>
              </select>
              <h4 className="montserrat">Exemplo: Convencional</h4>
            </div>
            <div className="input-component">
              <div>
                <h3 className="montserrat">Potência de TI</h3>
              </div>
              <input placeholder='Digite Aqui' name="potencia" onChange={onChange} type='text' />
              <h4 className="montserrat">Exemplo: 5.0</h4>
            </div>
            <div className="input-component">
              <div>
                <h3 className="montserrat">Área</h3>
              </div>
              <input name="area" onChange={onChange} placeholder='Digite Aqui' type='text' />
              <h4 className="montserrat">Exemplo: 1</h4>
            </div>
            <div className="input-component">
              <div>
                <h3 className="montserrat">Tipologia</h3>
              </div>
              <input name="tipologia" onChange={onChange} placeholder='Digite Aqui' type='text' />
              <h4 className="montserrat">Exemplo: N+2C</h4>
            </div>
            <div className="input-component">
              <div>
                <h3 className="montserrat">WKT</h3>
              </div>
              <input name="wkt" onChange={onChange} placeholder='Digite Aqui' type='text' />
              <h4 className="montserrat">Exemplo: POLYGON((-46.811461066034795 -23.495564336233297,-46.8106925640146947))</h4>
            </div>
          </div>
          <div style={show ? { display: 'flex' } : { display: 'none' }} className="button-okay-modal">
            <button onClick={() => postFile()} className="montserrat w600">Próximo</button>
          </div>

          <div className="button-okay-modal">
            <button style={show ? { display: 'block' } : { display: 'none' }} onClick={() => setShow(false)} className="montserrat w600">voltar</button>
            <button onClick={show ? () => callLoading() : () => setShow(true)}
              disabled={values?.eapId && file !== null && values?.eapId.match(/\s/) === null ? false : true}
              style={values?.eapId && file !== null && values?.eapId.match(/\s/) === null ? {} : { backgroundColor: '#ccc', cursor: 'not-allowed' }} className="montserrat w600">{show ? 'Adicionar' : 'Próximo'}</button>
          </div>
        </section>
      </div>

      <div id="background-edit" className="background-edit" style={modEdit === true ? { display: "block" } : { display: "none" }}>
        <section id="modal-edit" className="modal-edit">
          <div
            onClick=
            {() =>

              (animationModal("modal-edit", "background-edit"), setModEdit(false), console.log("fechou"))
            }
            className="fechar-button-style"
          >
            <img src={backHeader} alt="back" />
            <img src={backHeader} alt="back" />
            <h2 className="montserrat ">Fechar</h2>
          </div>
          <h1 className="montserrat azul w600">{obraSelecionada?.eapId}</h1>
          <div className="content-inputs">
            <div className="input-component">
              <div>
                <h3 className="montserrat">Fases</h3>
              </div>
              <input
                placeholder={
                  obraSelecionada.fases !== null
                    ? obraSelecionada.fases
                    : "Digite Aqui"
                }
                name="fases"
                onChange={onChange}
                type="number"
              />
              <h4 className="montserrat">Exemplo: 1</h4>
            </div>
            <div className="input-component">
              <div>
                <h3 className="montserrat">Tipo</h3>
              </div>
              <select name="tipo" onChange={onChange}>
                <option>
                  {obraSelecionada.tipo !== null
                    ? obraSelecionada.tipo
                    : "Selecione o Tipo"}
                </option>
                <option>Convencional</option>
                <option>Hibrid</option>
                <option>Fastdeploy</option>
              </select>
              <h4 className="montserrat">Exemplo: Convencional</h4>
            </div>
            <div className="input-component">
              <div>
                <h3 className="montserrat">Potência de TI</h3>
              </div>
              <input
                placeholder={
                  obraSelecionada.potencia !== null
                    ? obraSelecionada.potencia
                    : "Digite Aqui"
                }
                name="potencia"
                onChange={onChange}
                type="number"
              />
              <h4 className="montserrat">Exemplo: 5.0</h4>
            </div>
            <div className="input-component">
              <div>
                <h3 className="montserrat">Área</h3>
              </div>
              <input
                name="area"
                onChange={onChange}
                placeholder={
                  obraSelecionada.area !== null
                    ? obraSelecionada.area
                    : "Digite Aqui"
                }
                type="number"
              />
              <h4 className="montserrat">Exemplo: 5</h4>
            </div>
            <div className="input-component">
              <div>
                <h3 className="montserrat">Tipologia</h3>
              </div>
              <input
                name="tipologia"
                onChange={onChange}
                placeholder={
                  obraSelecionada.tipologia !== null
                    ? obraSelecionada.tipologia
                    : "Digite Aqui"
                }
                type="text"
              />
              <h4 className="montserrat">Exemplo: N+2C</h4>
            </div>
            <div className="input-component">
              <div>
                <h3 className="montserrat">WKT</h3>
              </div>
              <input
                name="wkt"
                onChange={onChange}
                placeholder={
                  obraSelecionada.wkt !== null
                    ? obraSelecionada.wkt
                    : "Digite Aqui"
                }
                type="text"
              />
              <h4 className="montserrat">
                Exemplo: POLYGON((-46.811461066034795
                -23.495564336233297,-46.8106925640146947))
              </h4>
            </div>
          </div>

          <div className="button-okay-modal">
            <button className="montserrat w600" style={{ display: 'none' }}>Cancelar</button>
            <button disabled={values === undefined} style={values === undefined ? { background: '#E2E2E2', cursor: 'not-allowed' } : {}} onClick={() => putGeral('Eap_Info', obraSelecionada?.eapId, obraSelecionada?.eapId)} className="montserrat w600">Alterar</button>
          </div>
        </section>
      </div>

      <ModalInfos
        checked={showModal}
        onClick={() => setShowModal(false)}
        label={label}
      />

      <ModalSure
        checked={showModal3}
        error
        label='Você realmente deseja exluir esse Projeto?'
        onClick={() => setShowModal3(false)}
        delete={() => deleteEap()}
      />

      <ModalInfos
        checked={showModal2}
        error
        onClick={() => setShowModal2(false)}
        label={labelError.label}
        sugestao={labelError.sugestao}
      />

    </section>
  )
}

export default NovoProjeto
